module.exports = __webpack_public_path__ + "img/qr.050be86c.jpg";